import {ReactNode} from "react";
import {useLocation} from "react-router-dom";
import {Page} from "./Entities/Page";
import {getPageStyleClassName} from "./Enums/PageStyle";
import Portfolio from "../Portfolios/Entities/Portfolio";
import IHavePageStyle from "./Entities/IHavePageStyle";
import {useMobile} from "../Context/MobileContext";

/**
 * Wrapper for the entire page.
 * @param children
 * @param pages
 * @param portfolios
 * @constructor
 */
function Container({children, pages, portfolios}: { children: ReactNode, pages: Page[], portfolios: Portfolio[] }) {
    const {isMobile} = useMobile();
    const location: string = useLocation().pathname;

    let currentPage: IHavePageStyle | undefined = pages.find(p =>
        // Find the page by its location
        p.path === location ||
        // Or it's alias
        p.aliases.find(a => a === location) !== undefined);

    let containerClasses: string[] = [];

    // We still cannot find the current page, maybe it's a portfolio
    if (!currentPage) {
        if (location.startsWith("/portfolio/")) {
            const portfolioPath = location
                .substring("/portfolio/".length)
                .split("/")[0];

            let selectedPortfolio = portfolios.find(p => p.path === portfolioPath);
            currentPage = selectedPortfolio;

            containerClasses.push("portfolio-page");
            containerClasses.push("portfolio-" + selectedPortfolio?.path);
        }
    }

    // This will be the theme className of the page tan or gray
    if (currentPage !== undefined) {
        containerClasses.push(getPageStyleClassName(currentPage.pageStyle));

        // The name of the page as a CSS class appended to the container
        if (currentPage.containerClassName) {
            containerClasses.push(currentPage.containerClassName);
        }
    }

    if (isMobile)
        containerClasses.push("mobile");

    return (<div id="container" className={containerClasses.join(" ")}>{children}</div>);
}

export default Container;